import React, {useEffect, useState } from "react";
import {
  Box,
  Container,
  Typography,
  Button,
  IconButton,
  useTheme,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  AppBar,
  Toolbar,
} from "@mui/material";
import { useParams,useLocation } from "react-router-dom";
import logoImage from "../../../components/devangles-logo-150.png";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { useAuth } from "./AuthContext";
import Tooltip from '@mui/material/Tooltip';
import useMediaQuery from "@mui/material/useMediaQuery";

const Header = () => {
  const theme = useTheme();
  const location = useLocation();
  const isMobile = useMediaQuery("(max-width:650px)");
  const isLaptop = useMediaQuery(theme.breakpoints.up("lg"));
  const is2XLarge = useMediaQuery("(min-width: 3840px)");
  const isLarge = useMediaQuery("(min-width: 1920px)");
  const [email, setEmail] = useState("");
  const pathParts = location.pathname.split("/");
  const id = pathParts[pathParts.length - 1];
  const { otpVerification, verifiedemail } = useAuth();

   useEffect(() => {
        const fetchEmail = async () => {
            if (
                location.pathname.includes("/shortlist-form/") ||
                location.pathname.includes("/selected-form/") ||
                location.pathname.includes("/onboarding-form/")
            ) {
                try {
          
                const res = await fetch(`${process.env.REACT_APP_BACKEND_URL_HRM}/job_application`);
                const data = await res.json();

                if (!res.ok) throw new Error(data.error || "Failed to fetch applications");

                const matchedApp = data.jobs.find((app) => app.id === id);
                if (matchedApp) {
                    setEmail(matchedApp.email || ""); 
                } else {
                    console.warn("No job application found with ID:", id);
                }
                } catch (error) {
                console.error("Error fetching email via backend:", error.message);
                }
            }
        };

        fetchEmail();
    }, [id, location]);



  return (
    <>
      {/* Fixed header */}
      <AppBar
        position="fixed" 
        elevation={0}
        sx={{
          bgcolor: "white",
          color: "black",
          paddingX: isLaptop ? "180px" : "16px",
          top: 0,
          zIndex: 1100,
        }}
      >
        <Container maxWidth="xl" disableGutters>
          <Toolbar
            sx={{
              borderBottom: "1px solid #eaeaea",
              padding: { xs: "8px 16px", sm: "12px 24px", md: "16px 32px" },
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              height: { xs: "auto", sm: "69px" },
              flexWrap: "nowrap",
              fontSize: "18px",
              fontFamily: "Lexend",
              color: "rgba(0, 0, 0, 0.87)",
            }}
          >
            {/* Logo */}
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Box
                component="picture"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  maxWidth: { xs: "140px", sm: "180px", md: "250px" },
                  width: { xs: "100%", sm: "auto" },
                  cursor: "pointer",
                }}
              >
                <source srcSet={logoImage} type="image/webp" />
                <img
                  src={logoImage}
                  alt="DevAngles logo"
                  loading="lazy"
                  height="22"
                  style={{
                    width: is2XLarge || isLarge ? 350 : 250,
                    objectFit: "contain",
                  }}
                />
              </Box>
            </Box>

            {/* Right side: Show text on large screens, icon on small screens */}
            <Box sx={{ display: "flex", alignItems: "center" }}>
              {otpVerification && (
                isMobile ? (
                <Tooltip title={`Login as ${email}`} arrow>
                  <IconButton size="large" sx={{ color: "rgba(0, 0, 0, 0.87)" }}>
                    <AccountCircleIcon sx={{ fontSize: 30 }} />
                  </IconButton>
                </Tooltip>
              ) : (
                <Typography
                  sx={{
                    fontFamily: "Lexend",
                    fontSize: "16px",
                    fontWeight: 500,
                    color: "rgba(0, 0, 0, 0.87)",
                  }}
                >
                  <b>Login as</b> {email}
                </Typography>
               )
              )}
            </Box>
          </Toolbar>
        </Container>
      </AppBar>

    </>
    
  );
};

export default Header;
